import { recentlyDashboardPosts } from "assets/data/dashboard";
import { Card, CardFilter, UpdatedPost } from "ui";
const UpdatedPosts = () => {
    return (
        <Card className="w-full h-full flex flex-col gap-5">
            <div className="flex flex-col justify-start items-start gap-2 dark:text-white">
                <h2 className="text-lg font-medium">Recently Updated Posts</h2>
                <CardFilter
                    dropDownItems={[
                        "Post ID",
                        "User ID",
                        "userName",
                        "Members Name",
                        "Country",
                        "Words",
                        "Post",
                        "Incident"
                    ]}
                />
            </div>
            <div
                className="flex flex-col justify-start items-center gap-5 w-full h-full bg-neutral-50 dark:bg-momeento-100 rounded overflow-auto"
                style={{ paddingTop: 10 }}
            >
                {recentlyDashboardPosts.map((r) => (
                    <UpdatedPost recentdPost={r} key={r.id} />
                ))}
            </div>
        </Card>
    );
};

export default UpdatedPosts;
